import React from 'react';
import { Box } from '@mui/material';
import { SweepParams } from '../../constants/bannerEffect';

/**
 * ヘッダーを横切る光。
 *
 * 層は1枚だけ。グラデーションを敷いた面を transform で流すので、
 * ラスタライズは初回の1回で終わる。**JSは走らない。**
 *
 * 【シマーに見せないための条件】
 * 素直に組むとローディングのスケルトンにそっくりになる。効くのは次の3つ。
 * - **周期の大半を待機に使う。** 通過は cross(%) の間だけで、残りは画面外にいる。
 *   グリッチが「大半は静止」なのと同じ考え方で、コストも同じ理由で安い
 * - **帯を広く、薄く。** 細くて濃い帯は読み込み中のハイライトそのものに見える
 * - **斜めにする。** 真横に走らせると余計にスケルトンらしくなる
 * 速度を上げると上の3つを守っても安っぽくなる。cycle は削らないこと。
 *
 * 待機位置は左右とも画面外なので、周回のつなぎ目（右端→左端の瞬間移動）は見えない。
 */
const BannerSweep: React.FC<{ params: SweepParams; accent: string }> = ({ params, accent }) => {
  const { cycle, cross, tinted, peak } = params;
  // 色は面の中央だけに置き、両側へ透明に落とす。
  // **透明側にも同じ色を使うこと（`transparent` と書かない）。**
  // CSS の `transparent` は rgba(0,0,0,0) なので、色付きの停止点との間で
  // 黒へ寄った灰色の帯が出る。同色のアルファ0なら色相を保ったまま消える。
  const light = tinted ? accent : '#ffffff';
  const band =
    `linear-gradient(135deg, `
    + `${light}00 30%, `
    + `${light}00 38%, `
    + `${light} 50%, `
    + `${light}00 62%, `
    + `${light}00 70%)`;
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        background: band,
        opacity: peak,
        // 通過は cross% の間だけ。以降は右の画面外で次の周回まで待つ
        '@keyframes bannerSweep': {
          '0%': { transform: 'translate3d(-105%, 0, 0)' },
          [`${cross}%, 100%`]: { transform: 'translate3d(105%, 0, 0)' },
        },
        animation: `bannerSweep ${cycle}s linear infinite`,
        willChange: 'transform',
        '@media (prefers-reduced-motion: reduce)': { animation: 'none', opacity: 0 },
      }}
    />
  );
};

export default BannerSweep;
